// 使用mock替代真实API调用，真实API代码已注释保留
import mockUserApi from '@/mock/user'
import { login, logout, getInfo, getMerchantInfo, getAdminInfo } from '@/api/user'
// import { getToken, setToken, removeToken } from '@/utils/auth'
import { resetRouter } from '@/router'
import Storage from '@/utils/storage';

const user = Storage.get('User') || {};

const ROLE = {
  admin: 'admin',
  merchant: 'merchant',
  agent: 'agent',
}

const state = {
  // 使用本地存储的token替代真实API的getToken()，真实代码已注释保留
  // token: getToken(),
  token: user.token || '',
  name: user.name || '',
  avatar: '',
  introduction: '',
  roles: user.roles || [],
  hasRoutesInited: false
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_USER_AUTH: (state, user) => {
    const { name, token, role } = user;
    state.name = name;
    state.token = token;
    state.roles = Array.isArray(role) ? role : role ? [role] : [];
    state.hasRoutesInited = false;
    Storage.set('User', { name, token, roles: state.roles });
    Storage.set('Token', token);
  },
  CLEAR_USER_AUTH: (state) => {
    state.name = '';
    state.token = '';
    state.roles = [];
    state.hasRoutesInited = false;
    Storage.remove('User');
    Storage.remove('Token');
  },
  SET_HAS_ROUTES_INITED: (state, hasRoutesInited) => {
    state.hasRoutesInited = hasRoutesInited;
  }
}

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { username, password, ...rest } = userInfo
    return new Promise((resolve, reject) => {
      // 使用mock API替代真实API调用，真实API代码已注释保留
      /* mockUserApi.login({ username: username.trim(), password: password, ...rest }).then(response => {
        if (response.code === 200) {
          commit('SET_USER_AUTH', response.data)
          resolve(response)
        } else {
          reject(new Error(response.message || '登录失败'))
        }
      }).catch(error => {
        reject(error)
      }) */
      // 真实API调用代码保留
      login({ username: username.trim(), password: password, ...rest }).then(response => {
        commit('SET_USER_AUTH', response.data)
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  getInfo({ commit, state }) {
    const api = state.roles.includes(ROLE.merchant) ? getMerchantInfo : getAdminInfo;
    return api().then(res => {
      const token = res?.data?.token || state.token;
      commit('SET_USER_AUTH', { ...res.data, token })
      return res.data;
    });
  },

  // get user info
  /* getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo(state.token).then(response => {
        const { data } = response

        if (!data) {
          reject('Verification failed, please Login again.')
        }

        const { roles, name, avatar, introduction } = data

        // roles must be a non-empty array
        if (!roles || roles.length <= 0) {
          reject('getInfo: roles must be a non-null array!')
        }

        commit('SET_ROLES', roles)
        commit('SET_NAME', name)
        commit('SET_AVATAR', avatar)
        commit('SET_INTRODUCTION', introduction)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  }, */

  // user logout
  logout({ commit, state, dispatch }) {
    // 使用mock接口模拟登出，真实API调用代码已注释保留
    // logout(state.token); // 真实API调用代码保留
    commit('CLEAR_USER_AUTH')
    resetRouter()
    // reset visited views and cached views
    // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
    dispatch('tagsView/delAllViews', null, { root: true })
  },

  // remove token
  resetToken({ commit, dispatch }) {
    return new Promise(resolve => {
      commit('CLEAR_USER_AUTH')
      resetRouter()
      dispatch('tagsView/delAllViews', null, { root: true })
      resolve()
    })
  },

  // dynamically modify permissions
  /* async changeRoles({ commit, dispatch }, role) {
    const token = role + '-token'

    commit('SET_TOKEN', token)
    setToken(token)

    const { roles } = await dispatch('getInfo')

    resetRouter()

    // generate accessible routes map based on roles
    const accessRoutes = await dispatch('permission/generateRoutes', roles, { root: true })
    // dynamically add accessible routes
    router.addRoutes(accessRoutes)

    // reset visited views and cached views
    dispatch('tagsView/delAllViews', null, { root: true })
  } */
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
